"use client";
import Image from "next/image";
import React from "react";
import { useRouter } from "next/navigation";
import InputSearch from "@/components/input-search/input-search";
import { categoriesData, dataCountry, years } from "@/data/constants";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import PageContent from "@/components/page-content/page-content";

const Header = () => {
  const [isRedirect, setIsRedirect] = React.useState<boolean>(true);
  const router = useRouter();
  const redirectHome = () => {
    router.push("/");
  };

  const handleClick = () => {
    if (isRedirect) {
      setIsRedirect(false);
      window.open(
        "https://www.profitableratecpm.com/jq5yf4utj7?key=aa3848ff8ca415aeec065877a1e5d169",
        "_blank"
      );
    }
  };

  return (
    <header className="sticky top-0 z-20 bg-colorMain backdrop-blur-md p-4 lg:px-[10%] flex justify-between items-center">
      <a
        href="/"
        className="text-2xl md:text-3xl font-bold text-orange-400 drop-shadow-[0_0_10px_rgba(236,72,153,0.8)]"
      >
        <Image
          alt=""
          unoptimized={true}
          quality={100}
          src={"/images/icon.png"}
          width={134}
          height={33}
          className="h-[33px] cursor-pointer object-cover"
          onClick={redirectHome}
        />
      </a>

      <div className="hidden md:flex items-center gap-4">
        <a
          href="/danh-sach/tv-shows"
          className="text-orange-400 hover:text-orange-300 transition-all duration-300 hover:shadow-[0_0_10px_rgba(236,72,153,0.5)]"
        >
          Tv shows
        </a>{" "}
        <a
          href="/danh-sach/phim-le"
          className="text-orange-400 hover:text-orange-300 transition-all duration-300 hover:shadow-[0_0_10px_rgba(236,72,153,0.5)]"
        >
          Phim lẻ
        </a>{" "}
        <a
          href="/danh-sach/phim-bo"
          className="text-orange-400 hover:text-orange-300 transition-all duration-300 hover:shadow-[0_0_10px_rgba(236,72,153,0.5)]"
        >
          Phim bộ
        </a>
        <DropdownMenu>
          <DropdownMenuTrigger className="text-orange-400 hover:text-orange-300 transition-all duration-300 hover:shadow-[0_0_10px_rgba(236,72,153,0.5)]">
            Thể loại
          </DropdownMenuTrigger>
          <DropdownMenuContent className="bg-black border-orange-400 text-white">
            {categoriesData.map((values, index) => {
              return (
                <DropdownMenuItem
                  onClick={() => {
                    // router.push(`/the-loai/${values.slug}`);
                    window.open(`/the-loai/${values.slug}`);
                    window.location.href = `https://www.profitableratecpm.com/jq5yf4utj7?key=aa3848ff8ca415aeec065877a1e5d169`;
                  }}
                  key={index}
                  className="hover:bg-orange-400 hover:text-white cursor-pointer"
                >
                  {values.title}
                </DropdownMenuItem>
              );
            })}
          </DropdownMenuContent>
        </DropdownMenu>
        <DropdownMenu>
          <DropdownMenuTrigger className="text-orange-400 hover:text-orange-300 transition-all duration-300 hover:shadow-[0_0_10px_rgba(236,72,153,0.5)]">
            Năm
          </DropdownMenuTrigger>
          <DropdownMenuContent className="bg-black border-orange-400 text-white">
            {years.map((values) => {
              return (
                <DropdownMenuItem
                  key={values}
                  onClick={() => {
                    window.open(`/nam/${values}`);
                    window.location.href = `https://www.profitableratecpm.com/jq5yf4utj7?key=aa3848ff8ca415aeec065877a1e5d169`;
                  }}
                  className="hover:bg-orange-400 hover:text-white"
                >
                  {values}
                </DropdownMenuItem>
              );
            })}
          </DropdownMenuContent>
        </DropdownMenu>
        <DropdownMenu>
          <DropdownMenuTrigger className="text-orange-400 hover:text-orange-300 transition-all duration-300 hover:shadow-[0_0_10px_rgba(236,72,153,0.5)]">
            Quốc gia
          </DropdownMenuTrigger>
          <DropdownMenuContent className="bg-black border-orange-400 text-white">
            {dataCountry.map((values) => {
              return (
                <DropdownMenuItem
                  key={values.slug}
                  onClick={() => {
                    window.open(`/quoc-gia/${values.slug}`);
                    window.location.href = `https://www.profitableratecpm.com/jq5yf4utj7?key=aa3848ff8ca415aeec065877a1e5d169`;
                  }}
                  className="hover:bg-orange-400 hover:text-white"
                >
                  {values.title}
                </DropdownMenuItem>
              );
            })}
          </DropdownMenuContent>
        </DropdownMenu>
        <InputSearch />
      </div>
      <div className="hidden max-md:block">
        <InputSearch />
      </div>
    </header>
  );
};

export default Header;
